export default {
    'diagram1-3a2': {
        'diagram-task': 'Fill in the rough summary and the simplified summary',
        'fixed-answer1': 'We need to look beyond GDP measures for a real picture of the economy',
        'fixed-answer2': 'GDP gives a false picture of the economy because it ignores the value created by digitization',
        'pre-fill': 'GDP gives a false picture of the economy because',

        'fixed-answer3': '<u>New technologies</u> have always driven out old ones, usually by entering the market economy and <u>boosting GDP</u>',
        'fixed-answer4': 'But <u>digitization</u> is distinctive in that much of the value it creates for consumers <u>never becomes part of</u> the economy that <u>GDP</u> measures',
        'fixed-answer5': 'Thus the gap between what’s actually happening in the economy and what the statistics measure is wider than ever',

        'complete-title': 'Reveal',
        'hide-title': 'Hide',
        'next-title': 'Next',
    }
};



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a2/diagram1/i18n/en.js